<template>
  <div id="app" class="landingDegraded">
    <LandingHeader />
    <LandingBody />
    <LandingFooter />
  </div>
</template>

<script>
import LandingHeader from "./components/landing/LandingHeader.vue";
import LandingBody from "./components/landing/LandingBody.vue";
import LandingFooter from "./components/landing/LandingFooter.vue";
export default {
  name: "App",
  metaInfo: {
    title: 'OSFATUN es la Obra Social de los Trabajadores NODOCENTES de las Universidades Nacionales.',
    titleTemplate: null,
    // titleTemplate: "Osfatun - %s",
    htmlAttrs: {
      lang: "es-ES",
    },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "author", content: "OSFATUN" },
      {
        name: "description",
        content:
          "OSFATUN es la Obra Social de los Trabajadores NODOCENTES de las Universidades Nacionales.",
      },
      {
        name: "keywords",
        content:
          "OSFATUN,Obra Social,NODOCENTES,Universidades Nacionales. Argentina, cartilla, prestadores",
      },
    ],
  },
  components: {
    LandingHeader,
    LandingBody,
    LandingFooter,
  },
};
</script>

<style>
@import "~bulma/css/bulma.css";
@import "assets/fonts-loader/main-loader.css";
* {
  padding: 0;
  margin: 0;
  font-family: "Gotham Rounded";
}
ul.icons {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: auto auto auto auto auto;
  justify-content: space-evenly;
  width: 100%;
}
ul.icons li {
  border: 1px solid #000;
  color: #000;
  font-weight: lighter;
  display: grid;
  float: left;
  font-size: 20px;
  align-content: center;
  justify-content: center;
  line-height: 1rem;
  position: relative;
  text-align: center;
}
@media screen and (max-width: 42em) {
  ul.icons{
    grid-template-columns: auto auto;
  }
}

</style>

<style scoped>
.landingDegraded {
  background: linear-gradient(
    to bottom,
    #0091bd 0%,
    #0091bd 36%,
    #f4f4f4 36%,
    #f4f4f4 100%
  );
}
@media screen and (max-width: 42em) {
  ul.icons{
    grid-template-columns: auto auto;
  }
  .landingDegraded {
    background: linear-gradient(
      to bottom,
      #0091bd 0%,
      #0091bd 15%,
      #f4f4f4 15%,
      #f4f4f4 100%
    );
  }
}
</style>
